module.exports = __webpack_public_path__ + "static/media/aline.f6df78f9.svg";